/**
 * Persist Control Bridge sidebar ``filterScope`` per workspace slug in sessionStorage
 * so a reload restores the last scope. Drive still sends ``drive_filter_scope`` as a
 * query param via ``kryspaceRenderService`` — that path is unchanged.
 */

export const FILTER_SCOPE_STORE_KEY_PREFIX = 'krysalis.controlBridge.filterScope.';

function storageKey(workspaceSlug: string): string {
  return `${FILTER_SCOPE_STORE_KEY_PREFIX}${workspaceSlug.trim()}`;
}

export function getFilterScope(workspaceSlug: string): string | null {
  const slug = workspaceSlug.trim();
  if (!slug) return null;
  try {
    if (typeof sessionStorage === 'undefined') return null;
    const raw = sessionStorage.getItem(storageKey(slug));
    const value = raw?.trim();
    return value ? value : null;
  } catch {
    return null;
  }
}

export function setFilterScope(workspaceSlug: string, filterScope: string): void {
  const slug = workspaceSlug.trim();
  const scope = filterScope.trim();
  if (!slug || !scope) return;
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(storageKey(slug), scope);
  } catch {
    /* ignore quota / private-mode */
  }
}

export function clearFilterScope(workspaceSlug: string): void {
  const slug = workspaceSlug.trim();
  if (!slug) return;
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(storageKey(slug));
  } catch {
    /* ignore */
  }
}
